export default __webpack_public_path__ + "static/8-8a2af8d0bd0420b861c07686482fed1e.jpg";